import { MascotBubble } from '@tankef/ui';

import type { StepType } from '@reactour/tour';

export const CONTACTS_TOUR_ID = 'contacts';

export const contactsSteps: StepType[] = [
  {
    selector: '[data-tour="contacts-add-btn"]',
    position: 'bottom',
    content: (
      <MascotBubble emotion="happy" size="sm" direction="left" showPointer={false}>
        Toca <strong>Agregar contacto</strong> para añadir a alguien. Busca por email o teléfono —
        si está en Tankef aparece automáticamente; si no, agrega su CLABE.
      </MascotBubble>
    ),
  },
  {
    selector: '[data-tour="contacts-table"]',
    position: 'top',
    content: (
      <MascotBubble emotion="neutral" size="sm" direction="right" showPointer={false}>
        Aquí están todos tus <strong>contactos</strong>. Puedes enviarles dinero directo desde aquí
        o editar su información.
      </MascotBubble>
    ),
  },
];
